import http from '@/services/http';
import { leadFormQuery } from '@/type/pages';
import { error } from '@/utils/safetyLog';

export const createLeadForm = async (requestData: leadFormQuery) => {
  const endpoint = '/salesforce/creatLead';
  const payload = {
    ...requestData,
  };
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error('Error creating lead form:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return null;
  }
};
